import { Entity } from '@hglobal/common';

export interface Team {
  balance: number;
  currency: string;
  description: string;
  feeProfile: FeeProfile;
  name: string;
  orgId: number;
  status: TeamStatus;
  statusText?: string;
  id: string | number;
  requiresApproval: boolean;
}

interface FeeProfile extends Entity<number> {
  cardIssuanceAmount: number;
  cardIssuanceCurrency: string;
  cardIssuanceEnable: boolean;
  cardIssuanceFree: number;
  created: number;
  name: string;
  topupFeeEnable: boolean;
  topupFeePercent: number;
  transactionDeclineAmount: number;
  transactionDeclineCurrency: string;
  transactionDeclineEnable: boolean;
  updated: number;
}

export enum TeamStatus {
  Active = 'active',
  Blocked = 'blocked',
  RequiredApproval = 'requiredApproval',
}
